/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

function normalizeBoostCollectionFilterInUrl() {
  var currentUrl = new URL(window.location.href);
  var filterValue = currentUrl.searchParams.get('pf_t_collection');
  var normalizedMap = {
    Procyon: 'PROCYON',
    Radium: 'RADIUM,Radium',
    RADIUM: 'RADIUM,Radium'
  };

  if (!filterValue) {
    return;
  }

  var normalizedFilterValue = normalizedMap[filterValue];

  if (!normalizedFilterValue || filterValue === normalizedFilterValue) {
    return;
  }

  currentUrl.searchParams.set('pf_t_collection', normalizedFilterValue);
  window.location.replace(currentUrl.toString());
}

function normalizeBoostCollectionFilterLinks() {
  var collectionFilterLinks = document.querySelectorAll('a[href*="pf_t_collection="]');
  var normalizedMap = {
    Procyon: 'PROCYON',
    Radium: 'RADIUM,Radium',
    RADIUM: 'RADIUM,Radium'
  };

  collectionFilterLinks.forEach(function(link) {
    try {
      var rawHref = link.getAttribute('href');

      if (!rawHref) {
        return;
      }

      var parsedHref = new URL(rawHref, window.location.origin);
      var filterValue = parsedHref.searchParams.get('pf_t_collection');

      if (!filterValue) {
        return;
      }

      var normalizedFilterValue = normalizedMap[filterValue];

      if (!normalizedFilterValue || filterValue === normalizedFilterValue) {
        return;
      }

      parsedHref.searchParams.set('pf_t_collection', normalizedFilterValue);
      link.setAttribute('href', parsedHref.pathname + parsedHref.search + parsedHref.hash);
    } catch (error) {
      // Ignore malformed URLs and leave them unchanged.
    }
  });
}

normalizeBoostCollectionFilterInUrl();
normalizeBoostCollectionFilterLinks();

function hideHeader() {
let headerElement = document.querySelector('#shopify-section-header');

if (location.hash === "#_" || location.hash.length === 0) {      
    headerElement.style.display = 'block';
}
else if (location.hash.includes("-feed")) {   
    headerElement.style.display = 'none';
    }
}
window.addEventListener('hashchange', hideHeader, false);